module.exports = __webpack_public_path__ + "media/images/acad_council/donald_kennedy-1a1a2fb3aca8fef4da2893a6f7505a2f.jpg";